export default __webpack_public_path__ + "static/media/loader.3a52956d.svg";